import izitoast from "izitoast";

export default izitoast;